<template>
    <div>
      <form class="mt-5">
          <div class="form-group row">
            <label for="nome" class="col-sm-2 col-form-label">Descrição: <span class='text-danger'> *</span></label>
            <div class="col-sm-5">
              <input type="text" class="form-control" v-model="desc" required>
            </div>
          </div>
          <div class="form-group row">
            <label for="staticEmail" class="col-sm-2 col-form-label">Ícone:<span class='text-danger'> * </span></label>
            <div class="col-sm-5">
              <i :class="'fas fa-' + icone"></i>
            <font-awesome-picker v-on:selectIcon="yourFunction" seachbox="Selecione o ícone desejado" required></font-awesome-picker>
            </div>
          </div>
      </form>

      <div class="container text-right mt-2">
        <button class="btn btn-sm btn-danger" @click="retorno">Retornar</button>
        <button class="btn btn-sm btn-success ml-2" :disabled="(!desc != '' || !icone != '')" @click="salvar">Salvar</button>
      </div>
    </div>
</template>

<script>
import MenuInternoCadastros from '../menu-interno/MenuInternoCadastros.vue'
import { fontAwesomePicker } from 'font-awesome-picker'

export default {
  name: 'TipoObrasCadastro',
  props: {
    classe: String
  },
  data () {
    return {
      icone: '',
      desc: ''
    }
  },
  components: {
    MenuInternoCadastros,
    'font-awesome-picker': fontAwesomePicker
  },
  methods: {
      retorno() {
        this.$router.go('/tipo-obras/listagem')
      },
      salvar() {
          API.enviarRequisicao('post', '/api/sist-obras/tipo-obras', {
              c01_descr: this.desc,
              c01_icone: this.icone
          })
        .then(response => {
          this.$swal('Parabéns!','Dados salvos com sucesso.','success')
          .then(
            function () {
            history.go(0);
            }
          )
        })
        .catch(function (error) {
          this.$swal('Atenção!','Erro ao cadastrar os dados.','error')
        })
      },
      yourFunction(selectedIcon) {
            this.icone = selectedIcon.className
        },
  }

}
</script>

<style scoped>
.salvar {
  background-color: #18A689;
  color: #fff;
  font-size: 12px;
  text-decoration: none;
}

</style>
